import React, { createContext, useContext, useState } from "react";

const AuthDialogContext = createContext();

export const useAuthDialog = () => {
  const context = useContext(AuthDialogContext);
  if (!context) {
    throw new Error("useAuthDialog must be used within AuthDialogProvider");
  }
  return context;
};

export const AuthDialogProvider = ({ children }) => {
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);
  const [loginFromCheckout, setLoginFromCheckout] = useState(false);

  const openLoginDialog = (fromCheckout = false) => {
    setLoginFromCheckout(fromCheckout);
    setShowLoginDialog(true);
    setShowRegisterDialog(false);
  };

  const openRegisterDialog = () => {
    setShowRegisterDialog(true);
    setShowLoginDialog(false);
  };

  const closeLoginDialog = () => {
    setShowLoginDialog(false);
    setLoginFromCheckout(false);
  };

  const closeRegisterDialog = () => {
    setShowRegisterDialog(false);
  };

  const switchToRegister = () => {
    setShowLoginDialog(false);
    setShowRegisterDialog(true);
  };

  const switchToLogin = () => {
    setShowRegisterDialog(false);
    setShowLoginDialog(true);
  };

  return (
    <AuthDialogContext.Provider
      value={{
        showLoginDialog,
        showRegisterDialog,
        loginFromCheckout,
        openLoginDialog,
        openRegisterDialog,
        closeLoginDialog,
        closeRegisterDialog,
        switchToRegister,
        switchToLogin,
      }}
    >
      {children}
    </AuthDialogContext.Provider>
  );
};

